<template>
  <div>
    <!-- actual cards -->
    <v-card
      class="my-1"
      v-for="(item, index) in items"
      :key="`accordion_${index}`"
    >
      <v-card-title @click="showBody($event, index)" class="accordion_title">
        <slot name="title" :item="item">
          <h4>Тайтл {{ index }} </h4>
        </slot>
        <v-icon 
          :class="{'mdi-rotate-180': isVisible[index]}"
          class="ml-auto"
        >mdi-chevron-down</v-icon>
      </v-card-title>

      <v-expand-transition>
        <div class="mb-2" v-show="isVisible[index]">
          <slot name="body" :item="item">
            <p>Содержимое</p>
          </slot>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- fake cards -->
    <div v-if="fakeItems.length > 0 && items.length !== fakeItems.length">
      <v-card
        v-for="(fakeItem, index) in fakeItems"
        :key="`accordion_fake_${index}`"
        v-show="!items[index]"
        class="accordion_fake-card"
      >
        <v-card-title class="accordion_fake-title">
          <slot name="fake_title" :item="fakeItem">
            <h4>Идёт загрузка... {{ index }}</h4>
          </slot>
        </v-card-title>

        <slot name="progress">
          <v-progress-linear
            v-if="!noProgress"
            color="warning"
            indeterminate
          ></v-progress-linear>
        </slot>
      </v-card>
    </div>

  </div>
</template>

<script>
/* 
  SLOTS:
  title         - действительный тайтл [прокидывается текущий item]
  body          - тело раскрытого аккардеона [прокидывается текущий item]
  fake_title    - тайтл при загрузке [прокидывается текущий item]
  progress      - поменять загрузку

  PROPS:
  items         - массив обычно report
  fakeItems     - массив ОБЯЗАТЕЛЬНО такой же длины как и ожидаемый items
  multiple      - можно открыть сколько угодно элементов --необязательный
  dontOpenFirst - не открывать первый загруженный --необязательный
  noProgress    - отключает дефолтную загрузку
*/
export default {
  name: "AccordionStatiz",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fakeItems: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    noProgress: {
      type: Boolean,
      default: false,
    },
    dontOpenFirst: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isVisible: [],
    };
  },

  computed: {
  },

  watch: {
    items(curr) {
      if (curr.length === 0) this.init();
    }
  },

  methods: {
    showBody(event, index) {
      let isShow = !this.isVisible[index];
      if (!this.multiple) this.fillIsVisible();
      this.isVisible.splice(index, 1, isShow);
      setTimeout(() => {
        let scrollTo = event.target.getBoundingClientRect().top + window.pageYOffset - 74;
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
      }, 400)
    },

    fillIsVisible() {
      this.isVisible = new Array(this.fakeItems.length).fill(false);
    },

    init() {
      this.fillIsVisible();
      if (!this.dontOpenFirst) this.isVisible.splice(0, 1, true);
    }
  },

  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoper>
.accordion_title {
  cursor: pointer;
  padding: 2px;
  padding-left: 10px;
}

.accordion_fake-card {
  margin:1px 0;
  min-height:52px;
  padding:2px 0;
}

.accordion_fake-title {
  padding:6px 0 0 10px;
  margin:2px 0;
}

</style>